import client from '../httpClient';

const settingGroupStoreSearchDetailApi = (params) => {
  return client.get('/store-groups/settings/detail/search/', { params });
};

export default settingGroupStoreSearchDetailApi;
